var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Thông tin điểm danh về: " + _vm.fullNameTitle,
            visible: _vm.dialogVisible,
            width: "1000px",
            "before-close": _vm.closeDialog,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "attendanceKid",
              attrs: {
                "label-width": "120px",
                model: _vm.attendanceKid.attendanceLeaveKids,
                "label-position": "top",
              },
            },
            [
              _c(
                "el-row",
                {
                  staticStyle: { "margin-top": "10px" },
                  attrs: { gutter: 20 },
                },
                [
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c("div", { staticClass: "shift-card" }, [
                      _c("div", { staticClass: "shift-header" }, [
                        _c("strong", [_vm._v("Điểm danh về")]),
                      ]),
                      _c("div", { staticClass: "shift-row two-columns" }, [
                        _c(
                          "div",
                          { staticClass: "shift-col shift-media" },
                          [
                            _c("div", { staticClass: "shift-media-title" }, [
                              _vm._v("Ảnh về"),
                            ]),
                            _c("image-uploader", {
                              attrs: {
                                preview:
                                  _vm.attendanceKid.attendanceLeaveKids
                                    .leaveUrlPicture,
                                placeholder: "Tải ảnh về",
                                updateAttendance: true,
                              },
                              model: {
                                value: _vm.imageUrl,
                                callback: function ($$v) {
                                  _vm.imageUrl = $$v
                                },
                                expression: "imageUrl",
                              },
                            }),
                            _c("div", { staticClass: "shift-time" }, [
                              _vm._v("\n                  Giờ về: "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatTime")(
                                      _vm.attendanceKid.attendanceLeaveKids
                                        .timeLeaveKid
                                    )
                                  )
                                ),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "shift-col shift-note" },
                          [
                            _c("div", { staticClass: "shift-media-title" }, [
                              _vm._v("Nội dung ghi chú về"),
                            ]),
                            _c("el-input", {
                              attrs: {
                                type: "textarea",
                                rows: 4,
                                placeholder: "Nhập nội dung ghi chú...",
                              },
                              model: {
                                value:
                                  _vm.attendanceKid.attendanceLeaveKids
                                    .leaveContent,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.attendanceKid.attendanceLeaveKids,
                                    "leaveContent",
                                    $$v
                                  )
                                },
                                expression:
                                  "attendanceKid.attendanceLeaveKids.leaveContent",
                              },
                            }),
                            _vm.attendanceKid.attendanceLeaveKids.idCreated !=
                            null
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "shift-status",
                                    staticStyle: { "margin-top": "20px" },
                                  },
                                  [
                                    _vm.attendanceKid.attendanceLeaveKids
                                      .createdDate !==
                                    _vm.attendanceKid.attendanceLeaveKids
                                      .lastModifieDate
                                      ? _c("div", [
                                          _vm._v(
                                            "\n                    Điểm danh lần cuối: "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.attendanceKid
                                                  .attendanceLeaveKids
                                                  .lastModifieBy
                                              )
                                            ),
                                          ]),
                                          _c("br"),
                                          _vm.attendanceKid.attendanceLeaveKids
                                            .lastModifieBy !== "Hệ thống"
                                            ? _c("span", [
                                                _vm.attendanceKid
                                                  .attendanceLeaveKids
                                                  .lastModifieBy !== "Hệ thống"
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "\n                        Thời gian sửa: " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatDateTime"
                                                            )(
                                                              _vm.attendanceKid
                                                                .attendanceLeaveKids
                                                                .lastModifieDate
                                                            )
                                                          )
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                              ])
                                            : _vm._e(),
                                        ])
                                      : _c("div", [
                                          _vm._v(
                                            "\n                    Điểm danh: "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.attendanceKid
                                                  .attendanceLeaveKids.createdBy
                                              )
                                            ),
                                          ]),
                                          _c("br"),
                                          _vm.attendanceKid.attendanceLeaveKids
                                            .createdBy !== "Hệ thống"
                                            ? _c("span", [
                                                _vm._v(
                                                  "\n                    Thời gian: " +
                                                    _vm._s(
                                                      _vm._f("formatDateTime")(
                                                        _vm.attendanceKid
                                                          .attendanceLeaveKids
                                                          .createdDate
                                                      )
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ])
                                            : _vm._e(),
                                        ]),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "danger", size: "medium" },
                  on: {
                    click: function ($event) {
                      return _vm.closeDialogByButton("attendanceKid")
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-circle-close" }),
                  _vm._v(" Đóng\n      "),
                ]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "success",
                    size: "medium",
                    loading: _vm.loadingButton,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm("attendanceKid")
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-circle-check" }),
                  _vm._v(" Lưu\n      "),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }